import {seoDefaults} from "@/seo/seoDefaults";
import ApiHelper from "@/helpers/ApiHelper";

export function buildMeta(
    opts: {
        title?: string;
        description?: string;
        image?: string;      // абсолютний або відносний
        url?: string;        // абсолютний або відносний
        useSuffix?: boolean;   // додавати суфікс до title
    }
) {
    const origin = ApiHelper.getUrlBase();

    let title: string;
    if (opts.title) {
        title = opts.useSuffix === false ? opts.title : `${opts.title} — ${seoDefaults.defaultTitle}`;
    } else {
        title = seoDefaults.defaultTitle;
    }
    const description = opts.description ?? seoDefaults.defaultDescription;

    const absUrl = new URL(opts.url, origin).toString();
    const absImg = new URL(opts.image ?? seoDefaults.defaultImage, origin).toString();

    return [
        {title},
        {name: "description", content: description},

        {property: "og:site_name", content: seoDefaults.siteName},
        {property: "og:title", content: title},
        {property: "og:description", content: description},
        {property: "og:type", content: "website"},
        {property: "og:url", content: absUrl},
        {property: "og:image", content: absImg},

        {name: "twitter:card", content: "summary_large_image"},
        {name: "twitter:title", content: title},
        {name: "twitter:description", content: description},
        {name: "twitter:image", content: absImg}
    ];
}
